import State from "./store/state";
import Getters from "./store/getters";
import Mutations from "./store/mutations";
import Actions from "./store/actions";

export default {
  namespaced: true,
  state: State,
  getters: Getters,
  mutations: Mutations,
  actions: Actions
};
